import React from "react";
import clsx from "clsx";
import styles from "./SegmentedControl.module.css";

export type SegmentedOption = { value: string; label: string };

type Props = {
  options: SegmentedOption[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
};

/**
 * A simple, robust Pickup/Delivery-style segmented toggle: equal-width
 * segments, the active one shown as a filled pill. (Replaces an earlier
 * clip-path dual-layer version that mis-laid-out the second segment.)
 */
const SegmentedControl: React.FC<Props> = ({
  options,
  value,
  onChange,
  className,
}) => (
  <div className={clsx(styles.control, className)} role="tablist">
    {options.map((o) => (
      <button
        key={o.value}
        type="button"
        role="tab"
        aria-selected={o.value === value}
        className={clsx(styles.segment, o.value === value && styles.segmentActive)}
        onClick={() => onChange(o.value)}
      >
        {o.label}
      </button>
    ))}
  </div>
);

export default SegmentedControl;
